import { styled } from '@mui/material';

export const SubTitle = styled('span')(() => ({
  marginBottom: 8,
  fontSize: 20,
  fontWeight: 600,
  color: '#202021',
  textTransform: 'uppercase',
}));
